import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  TemplateRef
} from '@angular/core';
import {
  DatasService,
  GetSubInstitutionsByPkGQL,
  Institutions,
  Institutions_Insert_Input
} from '@polylearn/models';
import { sortBy } from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, flatMap, map, tap } from 'rxjs/operators';
import { DialogService } from '../../../ui/dialog/dialog.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'apps/landing/src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminService } from '../../../admin/admin.service';
import { formatDate } from '@angular/common';

import { AngularFireStorage } from '@angular/fire/storage';
import slugify from 'slugify';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'polylearn-institutions-list',
  templateUrl: './institutions-list.component.html',
  styleUrls: ['./institutions-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstitutionsListComponent implements OnInit {
  @Input() institutionId: number;

  institutions$: Observable<Institutions[]>;
  updateInstitutions$ = new BehaviorSubject(null);

  dataSource;

  displayedColumns: string[] = [
    'logo',
    'name',
    'used_credits',
    // 'credits',
    // 'total_credits',
    'actions'
  ];

  editOrgForm: FormGroup = this.fb.group({
    id: null,
    name: [null, [Validators.required]],
    logo: null,
    slug: null
  });

  actions = [
    {
      text: 'institutions.list.watch_organization',
      icon: 'change_circle',
      click: (element: Institutions) => {
        console.log('element', element);
        this.adminService.go(element.id, 'manager', true);
      }
    },
    {
      text: 'institutions.list.see_credits',
      icon: 'data_usage',
      click: (element: Institutions) => {
        const registrations = element.registrations;
        console.log('element', element);
        this.dialogService.alert(
          {
            title: this.translate.instant([
              'institutions_list.dialog.credits_usage'
            ])['institutions_list.dialog.credits_usage'],
            /*
            icon: {
              name: 'data_usage'
            },
            */
            matDialogConfig: {
              width: '100%'
            }
          },
          {
            text: registrations
              .map(
                r =>
                  `<b>${formatDate(r.created_at, 'shortDate', 'en')}: ${
                    r.level
                  }</b> ${r.email} par ${r.creator?.email}`
              )
              .join('<br>')
          }
        );
      }
    }
  ];

  constructor(
    private getSubInstitutionsByPkGQL: GetSubInstitutionsByPkGQL,
    private cd: ChangeDetectorRef,
    private dialogService: DialogService,
    private fb: FormBuilder,
    private dataService: DatasService,
    private _snackBar: MatSnackBar,
    private adminService: AdminService,
    private storage: AngularFireStorage,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.institutions$ = this.updateInstitutions$.pipe(
      flatMap(() => this.getInstitutions())
    );

    console.log('this.institutions$', this.institutionId);
  }

  public yolo() {
    console.log('yolo');
    window.alert('yolo');
  }

  private getInstitutions(): Observable<Institutions[]> {
    return this.getSubInstitutionsByPkGQL
      .fetch(
        {
          institutionPk: this.institutionId
        },
        {
          fetchPolicy: 'no-cache',
          context: {
            headers: {
              role: 'manager'
            }
          }
        }
      )
      .pipe(
        map(
          res =>
            (res.data.institutions_by_pk
              .subInstitutions as any) as Institutions[]
        )
      )
      .pipe(
        tap(res => {
          setTimeout(() => {
            this.dataSource = sortBy(res, 'name');
            this.cd.detectChanges();
          });
        })
      );
  }

  public async openAddOrgDialog(
    templateRef: TemplateRef<any>,
    org: Institutions = null
  ) {
    let title;

    let tr = this.translate.instant([
      'institutions_list.dialog.create',
      'institutions_list.dialog.edit',
      'institutions_list.dialog.created',
      'institutions_list.dialog.saved'
    ]);
    if (!org) {
      title = tr['institutions_list.dialog.create'];
      this.editOrgForm.patchValue({
        id: null,
        name: null,
        logo: null,
        slug: null,
        parent_institution_id: this.institutionId
      });
    } else {
      title = tr['institutions_list.dialog.edit'];
      this.editOrgForm.patchValue({
        id: org.id,
        name: org.name,
        logo: org.logo,
        slug: org.slug,
        parent_institution_id: org.parent_institution_id
      });
    }

    this.dialogService
      .custom(
        {
          title: title
        },
        {
          content: templateRef
        }
      )
      .subscribe(res => {
        console.log(res);
        if (res) {
          if (!org) {
            let exams = {};
            exams[environment.EXAM] = true;
            const insertOrg: Institutions_Insert_Input = {
              name: res.name,
              logo: res.logo || '',
              credits: 0,
              slug: res.slug || null,
              exams,
              parent_institution_id: this.institutionId
            };
            console.log('insertOrg', insertOrg);
            this.dataService
              .insertData$<Institutions>(
                'institutions',
                'manager',
                insertOrg as any,
                'id'
              )
              .subscribe(async r => {
                setTimeout(() => {
                  this.updateInstitutions$.next('update');
                }, 300);
                this._snackBar.open(
                  tr['institutions_list.dialog.created'],
                  null,
                  {
                    duration: 5000
                  }
                );
              });
          } else {
            this.dataService
              .updateData$<Institutions>(
                'institutions',
                'manager',
                org.id,
                {
                  name: res.name,
                  logo: res.logo || '',
                  slug: res.slug || null
                },
                'id'
              )
              .subscribe(async r => {
                setTimeout(() => {
                  this.updateInstitutions$.next('update');
                }, 300);
                this._snackBar.open(
                  tr['institutions_list.dialog.saved'],
                  null,
                  {
                    duration: 5000
                  }
                );
              });
          }
        }
      });
  }

  public getUrl() {
    let value = this.editOrgForm.value;

    if (!value.slug) {
      return null;
    }

    if (value.slug) {
      return `https://${window.location.hostname}/login?org=${value.slug}`;
    }
  }

  public uploadFile(event) {
    console.log('🔥');
    const file = event.target.files[0];
    if (file.size > 350000) {
      this._snackBar.open('Le fichier est trop lourd', null, {
        duration: 5000
      });
      return;
    }
    const filePath = `/institutions/${new Date().toISOString()}`;

    const fileRef = this.storage.ref(filePath);
    console.log('xxx');
    const task = this.storage.upload(filePath, file);
    console.log('xxx');
    let x = this._snackBar.open(`Logo en cours de téléchargement`, null, {});

    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe(rr => {
            x.dismiss();
            console.log(rr);
            this.editOrgForm.patchValue({
              logo: rr
            });
          });
        })
      )
      .subscribe();
  }

  public generateSlug() {
    let value = this.editOrgForm.value;

    this.editOrgForm.patchValue({
      slug: slugify(value.name, {
        lower: true
      })
    });
  }
}
